import { MouseEventHandler, ReactNode } from 'react';
import { Box, ComponentWithAs, Flex, IconProps, Text } from '@chakra-ui/react';
import { useHistory, useLocation } from 'react-router-dom';
import Container from 'components/PageContainer';
// import { useAuthContext } from 'context/AuthProvider'
import {
  HomeIcon,
  ReferencesIcon,
  DocumentsIcon,
  ToDoIcon,
} from 'components/Icons';

const NavItem = ({
  selected,
  text,
  onClick,
  icon: Icon,
}: {
  selected: boolean;
  text: string;
  onClick: MouseEventHandler<HTMLElement>;
  icon: ComponentWithAs<'svg', IconProps>;
}): JSX.Element => {
  return (
    <Flex
      flex={0.33}
      minWidth={['65px', '130px', '130px', '130px']}
      direction="column"
      alignItems="center"
      cursor="pointer"
      onClick={onClick}
    >
      <Box
        height={1}
        width={16}
        bg={selected ? 'custom.levoYellow' : 'transparent'}
        mb={2}
      />
      <Flex
        flexGrow={1}
        boxSize={8}
        justifyContent="center"
        alignItems="center"
        position="relative"
      >
        <Flex position="absolute" zIndex={2}>
          <Icon
            p={1}
            boxSize="30px"
            color={selected ? 'custom.levoBlue' : 'custom.levoLightBlue'}
          />
        </Flex>
        {selected && (
          <Flex
            position="absolute"
            zIndex={1}
            alignSelf="flex-end"
            filter="blur(4px)"
          >
            <Icon p={1} boxSize="30px" color="custom.levoBlue" opacity={0.5} />
          </Flex>
        )}
      </Flex>
      <Text
        textStyle="preTitle"
        align="center"
        color={selected ? 'custom.levoBlue' : 'custom.levoLightBlue'}
        mb={4}
      >
        {text}
      </Text>
    </Flex>
  );
};

const Layout = ({
  children,
  showNavBar = true,
}: {
  children: ReactNode;
  showNavBar?: boolean;
}): JSX.Element => {
  const history = useHistory();
  const { pathname } = useLocation();
  // const {
  //   limit = 5,
  //   views = 0,
  // } = useAuthContext();

  // const viewDiff = limit - views;

  const goToPage = (page: string) => {
    history.push(page);
  };
  return (
    <Container>
      <Flex direction="column" height="100%" pb={['75px', 0, 0, 0]}>
        {children}
      </Flex>
      {showNavBar && (
        <Flex
          direction="column"
          alignItems="center"
          position="fixed"
          bottom={0}
          width="inherit"
          pointerEvents="none"
        >
          <Flex
            direction="row"
            justifyContent="space-around"
            width={['100%', 'fit-content', 'fit-content', 'fit-content']}
            borderTopWidth={['0.5px', 0, 0, 0]}
            borderLeftWidth={0}
            borderRightWidth={0}
            borderBottomWidth={0}
            pointerEvents="auto"
            bg="custom.levoWhite"
            boxShadow="4px 0px 20px 2px rgba(0, 0, 0, 0.06)"
            mb={[0, 0, 4, 4]}
          >
            <NavItem
              selected={pathname === '/home'}
              text="Home"
              icon={HomeIcon}
              onClick={() => goToPage('/home')}
            />
            {/* <Flex
              flex={0.25}
              minWidth="80px"
              direction="column"
              alignItems="center"
              cursor="pointer"
              onClick={() => goToPage('/jobs')}
              position="relative"
            >
              <Flex position="relative">
                <IconButton
                  variant="ghost"
                  height="fit-content"
                  aria-label="Jobs Icon"
                  pointerEvents="none"
                  icon={<JobsIcon fill={pathname === '/jobs' ? "#259BE9" : "#666"}/>}
                />
                {viewDiff > 0 && (
                  <Flex
                    height="15px"
                    width="15px"
                    borderRadius="50%"
                    color="#FFFFFF"
                    fontWeight={700}
                    fontSize="12px"
                    bgColor="#FF537C"
                    position="absolute"
                    justifyContent="center"
                    alignItems="center"
                    right={1}
                    top={-1}
                  >
                    {viewDiff}
                  </Flex>
                )}
              </Flex>
              <Text
                fontSize="12px"
                fontWeight={700}
                color={pathname === '/jobs' ? "#259BE9" : "#666"}
              >
                Jobs
              </Text>
            </Flex> */}
            <NavItem
              selected={pathname === '/references'}
              text="References"
              icon={ReferencesIcon}
              onClick={() => goToPage('/references')}
            />
            <NavItem
              selected={pathname === '/documents'}
              text="Documents"
              icon={DocumentsIcon}
              onClick={() => goToPage('/documents')}
            />
            <NavItem
              selected={pathname === '/todo'}
              text="To Do"
              icon={ToDoIcon}
              onClick={() => goToPage('/todo')}
            />
          </Flex>
        </Flex>
      )}
    </Container>
  );
};

export default Layout;
